import React from 'react';
import { formatOrderDateToLocalTime } from 'util/formatUtil';
import {
  ResultsColumn,
  ResultsColumnHeader,
  Row,
  HeaderRow,
  TitleTextLight,
  ShippingAddressWrapper,
  SubTitleTextLight,
  BoldSpan,
} from '../../DTInfoWidget.styles';

const OrderItem = ({ item, description, orderDate, status, productLink, trackingLink }) => (
  <Row key={JSON.stringify(item)} className="fs-block">
    <ResultsColumn>{description}</ResultsColumn>
    <ResultsColumn>{formatOrderDateToLocalTime(orderDate, 'revolve')}</ResultsColumn>
    <ResultsColumn>{status}</ResultsColumn>
    <ResultsColumn>{trackingLink ? TrackingLink(trackingLink) : '-'}</ResultsColumn>
    <ResultsColumn>{productLink ? ProductLink(productLink) : '-'}</ResultsColumn>
  </Row>
);

export const Items = ({ revolveOrderInfoWidgetData }) => (
  <>
    {revolveOrderInfoWidgetData.map((item) => {
      const { description, productLink, status, trackingLink, orderDate } = item;

      return (
        <OrderItem
          item={item}
          description={description}
          orderDate={orderDate}
          status={status}
          trackingLink={trackingLink}
          productLink={productLink}
        />
      );
    })}
  </>
);

const TrackingLink = (trackingLink) => (
  <a href={trackingLink} target="_blank" rel="noopener noreferrer">
    Tracking Link
  </a>
);

const ProductLink = (productLink) => (
  <a href={productLink} target="_blank" rel="noopener noreferrer">
    Product Link
  </a>
);

export const Headers = () => (
  <HeaderRow>
    <ResultsColumnHeader>ITEM DESCRIPTION</ResultsColumnHeader>
    <ResultsColumnHeader>CREATED AT</ResultsColumnHeader>
    <ResultsColumnHeader>STATUS</ResultsColumnHeader>
    <ResultsColumnHeader>TRACKING LINK</ResultsColumnHeader>
    <ResultsColumnHeader>PRODUCT LINK</ResultsColumnHeader>
  </HeaderRow>
);

export const ShippingAddress = ({ shippingAddress }) => (
  <ShippingAddressWrapper>
    <TitleTextLight>SHIPPING ADDRESS:</TitleTextLight>
    <SubTitleTextLight>
      <BoldSpan>Zip Code &rarr;</BoldSpan> {shippingAddress.zip}
    </SubTitleTextLight>
    <SubTitleTextLight>
      <BoldSpan>Country &rarr;</BoldSpan> {shippingAddress.country}
    </SubTitleTextLight>
  </ShippingAddressWrapper>
);
